import React, {ReactElement} from "react";
import {Listbox} from "@headlessui/react";
import {Language, LANGUAGES} from "./translations";
import {FormattedMessage} from "react-intl";
import {ReactComponent as ChevronDown} from "components/Icons/chevron-down.svg";

export interface LanguageDropdownProps {
    value: Language
    onChangeValue: (value: Language) => void
    buttonClassName: string
}

export function LanguageDropdown(props: LanguageDropdownProps): ReactElement {
    return (
        <Listbox as="div"
                 className="relative w-full"
                 value={props.value}
                 onChange={props.onChangeValue}>
            <Listbox.Button className={props.buttonClassName ?? ""}>
                <div className="flex items-center gap-1 w-full">
                    <div className="flex-auto"><FormattedMessage id={`language.${props.value}`} /></div>
                    <div className="flex-none mr-2"><ChevronDown className="w-3 h-3 text-secondary"/></div>
                </div>
            </Listbox.Button>
            <Listbox.Options className="absolute min-w-full l-0 mt-1 overflow-auto
                                        rounded-md drop-shadow-dropdown-menu bg-white
                                        font-barlow text-base py-4 z-popover">
                {LANGUAGES.map(language => (
                    <Listbox.Option
                        key={language}
                        value={language}
                        className={({selected}) => `hover:bg-secondary leading-loose px-4 ${selected ? 'text-primary' : ''}`}
                    >
                        <FormattedMessage id={`language.${language}`} />
                    </Listbox.Option>
                ))}
            </Listbox.Options>
        </Listbox>
    );
}